




















import Api from '@/helpers/Api';
import { Component, Vue } from 'vue-property-decorator';
import MundoBancanteHeader from '../components/MundoBancante/MundoBancanteHeader.vue';
import TextMedium from '../components/Text/TextMedium.vue';
import Button from '../components/Button/Button.vue';
import InputText from '../components/Input/InputText.vue';

@Component({
  components: {
    MundoBancanteHeader,
    TextMedium,
    Button,
    InputText,
  },
})
export default class MagicLink extends Vue {
  private error = '';

  private email = '';

  private loading = false;

  private validateEmail = (email: string) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  }

  async sendMagicLink() {
    this.error = '';
    if (!this.validateEmail(this.email)) {
      this.error = 'Introduce un correo válido';
      return;
    }

    this.loading = true;
    try {
      const bodyFormData = new FormData();

      const recaptcha = await (window as any).grecaptcha.execute('6Ld94sYqAAAAAH01qO5fNKD-qDbSaq-8k6qHw-O9', { action: 'validate_captcha' });
      if (!recaptcha) {
        this.error = 'Error en el captcha';
        this.loading = false;
        return;
      }
      bodyFormData.append('g-recaptcha-response', recaptcha || '');

      bodyFormData.append('payer_email', this.email);

      const res = await fetch(`${Api.api}subscription/magicLinkRequest`, {
        method: 'POST',
        body: bodyFormData,
      });

      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        this.error = err.message || 'Error al enviar el enlace. Intentá de nuevo. Si esto sigue pasando contactanos a estamosaprendiendo@elgatoylacaja.com';
        this.loading = false;
        return;
      }

      // On success, navigate to EmailSent view (already in project)
      this.$router.push({ name: 'EmailSent', query: { email: this.email } });
    } catch (e) {
      this.error = 'Error de red. Comprueba tu conexión. Si esto sigue pasando contactanos a estamosaprendiendo@elgatoylacaja.com';
    } finally {
      this.loading = false;
    }
  }
}

